//libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack, Typography } from '@lyearn/ui';
import getHumanDuration from '@/utils/time/getHumanDurationRounded';

import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
//helpers
import { FooterProps } from './types';

const Footer: React.FC<FooterProps> = (props) => {
  const { leftDuration, durationLabel } = props;

  const { t } = useTranslation();

  const leftTimeLesson = getHumanDuration(leftDuration) || t('Course:Lesson.aboutMinute');

  return (
    <Stack
      className="native:end-16 native:bottom-12 absolute bottom-24 w-full end-32 xs:hidden"
      justifyContent="end">
      <Typography className="me-8 text-end" color="text-text-placeholder" variant="body-short-03">
        {leftTimeLesson} {durationLabel}
      </Typography>
    </Stack>
  );
};

// Handle intersection observer for footer inside footer container, so parent component doesn't re-render
const FooterContainer: React.FC<
  FooterProps & {
    bottomRef: React.MutableRefObject<HTMLDivElement | null>;
    editorContainerRef: React.MutableRefObject<HTMLDivElement | null>;
  }
> = ({ bottomRef, editorContainerRef, ...rest }) => {
  const { isVisible } = useIntersectionObserver(bottomRef?.current, editorContainerRef?.current);

  if (isVisible) {
    return null;
  }

  return <Footer {...rest} />;
};

export default FooterContainer;
